import React from "react";
import { Page } from "../../components/page/page";
import styles from "./storm.module.css";
import { ChooseButton } from "../../components/choose-button/choose-button";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setStorm } from "../../store/stateSlice";

const options = [
  {
    value: "Excited, I love the power & energy of a storm",
    icon: "🤩",
  },
  {
    value: "Indifferent, storms don't really affect me",
    icon: "🙅‍♀️",
  },
  {
    value: "I feel anxious and prefer to stay indoors",
    icon: "😳",
  },
  {
    value: "Not sure",
    icon: "🤔",
  },
];

const StormPage = () => {
  const dispatch = useDispatch();
  return (
    <Page
      title="How do thunderstorms affect you?"
      hideContinueButton={true}
      currentStep={5}
    >
      <ul className={styles.list}>
        {options.map((option, i) => (
          <li key={i}>
            <Link
              to="../nature"
              onClick={() => dispatch(setStorm(option.value))}
            >
              <ChooseButton icon={option.icon}>{option.value}</ChooseButton>
            </Link>
          </li>
        ))}
      </ul>
    </Page>
  );
};

export { StormPage };
